import React from "react";
import i18next from "i18next";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { FiX, FiTrash2 } from "react-icons/fi";
import { MdPlaylistAddCheck } from "react-icons/md";
import { notificationsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import SwitchField from "components/SwitchField";

// Para cuando se pueda editar fecha:
// import { FiCalendar } from "react-icons/fi";
// import DatePicker, { registerLocale } from "react-datepicker";
// import moment from "moment";
// import "react-datepicker/dist/react-datepicker.css";
// import es from "date-fns/locale/es"; // datepicker locale
// registerLocale("es", es);

class NotificationEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let notification = {
			group_id: 0,
			// start_day: "",
			title: "",
			body: "",
			send_email: false,
		};

		let isEdit = false;

		if (props.notification) {
			notification = {
				...props.notification,
				send_email: Boolean(props.notification.send_email),
			};
			isEdit = true;
		}

		const selected_groups = Array.isArray(notification.groups)
			? notification.groups
			: [];

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			notification,
			temp_group: "",
			selected_groups: selected_groups,
			files: [], // <-- dropzone temporales
		};
	}

	handleChange = (event) => {
		const { notification } = this.state;
		const key = event.target.id;
		const value = event.target.value;
		if (key === "temp_group") {
			this.setState({ temp_group: value });
			return;
		}

		this.setState({
			notification: {
				...notification,
				[key]: value,
			},
		});
	};

	handleSwitch = (event) => {
		const { notification } = this.state;

		this.setState({
			notification: {
				...notification,
				[event.target.id]: event.target.checked,
			},
		});
	};

	// descomentar cuando se pueda editar fecha
	// handleDateChange = (id, date) => {
	// 	const { notification } = this.state;
	// 	let key = id;
	// 	let value = date ? moment(date).format("YYYY-MM-DD") : null;

	// 	this.setState({
	// 		notification: {
	// 			...notification,
	// 			[key]: value,
	// 		},
	// 	});
	// };

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });

		const props = this.props;
		const { notification, selected_groups, files } = this.state;

		const payload = {
			...notification,
			group_ids: selected_groups.map((g) => g.id),
		};
		delete payload.groups;

		let response = "";
		let hasErrors = false;
		let errorMsg = "";
		const hasFiles = files.length > 0;

		// UPDATE
		if (this.state.isEdit) {
			response = await notificationsService.update(payload);

			if (response.ok && hasFiles) {
				const formData = new FormData();
				files.forEach((f) => formData.append("filename", f)); // igual que workflows

				const respAtt = await notificationsService.addAttachments(
					payload.id,
					formData
				);

				if (!respAtt.ok) {
					hasErrors = true;
					errorMsg = errorFormating(respAtt);
				}
			}
		}
		// CREATE
		else {
			if (hasFiles) {
				const formData = new FormData();
				files.forEach((f) => formData.append("filename", f));

				const blob = new Blob([JSON.stringify(payload)], {
					type: "application/json",
				});

				formData.append("notification", blob);

				response = await notificationsService.addWithAttachments(formData);
			} else {
				response = await notificationsService.add(payload);
			}
		}

		if (!response.ok) {
			hasErrors = true;
			errorMsg = errorFormating(response);
		}

		if (!hasErrors) {
			this.setState(
				{
					isLoading: false,
					errors: {},
					files: [],
				},
				() => {
					toastr.success(i18next.t("common.success"), i18next.t("common.changesSaved"));
					props.getNotifications();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorMsg,
			});
		}
	};

	// ADJUNTOS
	onDrop = (files) => {
		this.setState({ files });
	};

	removeFile = (file) => {
		const { files } = this.state;
		this.setState({
			files: files.filter((f) => f.lastModified !== file.lastModified),
		});
	};

	removeAttachment = async (attachment) => {
		const { notification } = this.state;

		const response = await notificationsService.removeAttachment(
			notification.id,
			attachment.url
		);

		if (response.ok) {
			this.setState({
				notification: {
					...notification,
					attachments: (notification.attachments || []).filter(
						(att) => att.url !== attachment.url
					),
				},
			});
		}
	};

	addAllShifts = () => {
		const { groups } = this.props;
		if (groups && groups.length > 0) {
			this.setState({ selected_groups: groups });
		}
	};

	// GROUPS
	addGroup = () => {
		let { selected_groups, temp_group } = this.state;
		let isValid = true;
		let group;

		if (temp_group === undefined) {
			isValid = false;
		} else {
			group = this.props.groups.find(
				(item) => item.id === parseInt(temp_group)
			);
			if (group === undefined) {
				isValid = false;
			}
		}

		if (isValid) {
			// check if group already exists
			const exists = selected_groups.find(
				(item) => item.id === parseInt(temp_group)
			);

			// if not : add new group
			if (!exists) {
				selected_groups = selected_groups.concat(group);
			}

			this.setState({
				selected_groups,
				temp_group: "",
			});
		}
	};

	removeGroup = (idGroup) => {
		this.setState((prevState, props) => {
			return {
				selected_groups: prevState.selected_groups.filter(
					(item) => item.id !== parseInt(idGroup)
				),
			};
		});
	};

	getSelectedGroups = () =>
		this.state.selected_groups.map((item) => {
			return (
				<li key={item.id} className="tag-default tag-delete">
					{item.name}
					<button
						type="button"
						onClick={() => this.removeGroup(item.id)}
						className="btn-tag-delete btn-transparent"
					>
						<FiX />
					</button>
				</li>
			);
		});

	render() {
		const { groups, getAttachment } = this.props;
		const { notification, temp_group, selected_groups } = this.state;

		const optionList =
			groups.length > 0 &&
			groups.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		const attachments =
			notification.attachments &&
			notification.attachments.map((attachment) => {
				let size = attachment.size / 1000000;
				let sizeLetters = "Mb";
				if (size < 1) {
					size = attachment.size / 1000;
					sizeLetters = "Kb";
				}

				return (
					<li className="file-item" key={attachment.url}>
						<span
							className="file-info"
							title={attachment.name}
							onClick={() => getAttachment(notification, attachment)}
						>
							<span className="file-name">{attachment.name}</span>
							<span className="file-size">
								({size.toFixed(2)}
								{sizeLetters})
							</span>
						</span>

						<div className="file-action">
							<MdPlaylistAddCheck className="file-saved" />
							<button
								type="button"
								className="btn btn-icon"
								title={i18next.t("common.delete")}
								onClick={() => this.removeAttachment(attachment)}
							>
								<FiTrash2 />
							</button>
						</div>
					</li>
				);
			});

		const files =
			this.state.files.length > 0 &&
			this.state.files.map((file, i) => {
				let size = file.size / 1000000;
				let sizeLetters = "Mb";
				if (size < 1) {
					size = file.size / 1000;
					sizeLetters = "Kb";
				}

				return (
					<li className="file-item-temp" key={i}>
						<span className="file-info" title={file.name}>
							<span className="file-name">{file.name}</span>
							<span className="file-size">
								({size.toFixed(2)}
								{sizeLetters})
							</span>
						</span>

						<div className="file-action">
							<button
								type="button"
								className="btn btn-icon"
								title={i18next.t("common.delete")}
								onClick={() => this.removeFile(file)}
							>
								<FiTrash2 />
							</button>
						</div>
					</li>
				);
			});

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body modal-comunicacion">
					<div className="flex-group-wrapper mb25">
						<div className="flex-group mb15">
							<FormGroup className="form-group" controlId="temp_group">
								<FormLabel>
									{i18next.t("notifications.labelGroups")} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									onChange={this.handleChange}
									value={temp_group}
									placeholder={i18next.t("notifications.selectGroup")}
									isInvalid={this.checkValidField("group_ids")}
									as="select"
								>
									<option value="">{i18next.t("notifications.selectGroup")}</option>
									{optionList}
								</FormControl>
								<FormControl.Feedback type="invalid">
									{i18next.t("notifications.feedbackGroups")}
								</FormControl.Feedback>
							</FormGroup>

							<button
								type="button"
								onClick={this.addGroup}
								className="btn btn-primary"
							>
								{i18next.t("common.add")}
							</button>
						</div>

						{selected_groups.length === 0 && (
							<div className="row-adding-help">
								<button
									className="btn-link"
									type="button"
									onClick={this.addAllShifts}
								>
									{i18next.t("notifications.addAllGroups")}
								</button>
							</div>
						)}

						{/* Tags */}
						{selected_groups.length > 0 && (
							<ul className="list-tags">{this.getSelectedGroups()}</ul>
						)}
					</div>

					<FormGroup className="form-group" controlId="title">
						<FormLabel>
							{i18next.t("notifications.labelTitle")} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={notification.title}
							onChange={this.handleChange}
							placeholder={i18next.t("notifications.placeholderTitle")}
							isInvalid={this.checkValidField("title")}
							className="form-control"
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.title}
						</FormControl.Feedback>
					</FormGroup>
					<FormGroup className="form-group" controlId="body">
						<FormLabel>
							{i18next.t("notifications.labelBody")} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							as="textarea"
							value={notification.body}
							onChange={this.handleChange}
							placeholder={i18next.t("notifications.placeholderBody")}
							isInvalid={this.checkValidField("body")}
							className="form-control"
							style={{ height: 110 }}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.body}
						</FormControl.Feedback>
					</FormGroup>

					<SwitchField
						controlId="send_email"
						className="form-group mb15"
						isOn={Boolean(notification.send_email)}
						onToggle={this.handleSwitch}
						label={i18next.t("notifications.sendEmail")}
						disabled={this.state.isEdit}
					/>

					<label className="form-label">{i18next.t("notifications.attachDocuments")}</label>

					<Dropzone onDrop={this.onDrop}>
						{({ getRootProps, getInputProps }) => (
							<section className="dropzone-container">
								<div {...getRootProps({ className: "dropzone" })}>
									<input {...getInputProps()} />
									<p>{i18next.t("notifications.dropzoneText")}</p>
								</div>

								<ul className="dropzone-files">
									{attachments}
									{files}
								</ul>
							</section>
						)}
					</Dropzone>

					{/* <FormGroup
						controlId="start_day"
						className={`form-group form-date ${
							(notification.start_day === "" || !notification.start_day) &&
							"empty"
						}  ${this.checkValidField("start_day") && "is-invalid"}`}
					>
						<FormLabel>Fecha</FormLabel>

						<DatePicker
							selected={
								notification.start_day === "" || !notification.start_day
									? notification.start_day
									: moment(notification.start_day).toDate()
							}
							onChange={(date) => this.handleDateChange("start_day", date)}
							isInvalid={this.checkValidField("start_day")}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							locale="es"
							placeholderText="dd/mm/aaaa"
						/>

						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{this.state.errors.start_day}
						</FormControl.Feedback>
					</FormGroup> */}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{i18next.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={i18next.t("common.save")}
						loadingText={i18next.t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (state, myProps) => {
	return {
		groups: state.groupsReducer.groups,
	};
};

export default connect(mapStateToProps, null)(NotificationEdit);
